import { initAnalyticsClient, MIXPANEL_PLUGIN } from "@analytics/client";

const analyticsClient = initAnalyticsClient({
  app: "spirii-ui",
  debug: import.meta.env.DEV,
  plugins:
    import.meta.env.VITE_MIXPANEL_TOKEN && !import.meta.env.VITE_LOCAL
      ? [
          {
            type: MIXPANEL_PLUGIN,
            token: import.meta.env.VITE_MIXPANEL_TOKEN as string,
            instanceName: "spirii-ui",
            options: {
              autocapture: {
                pageview: "url-with-path-and-query-string",
                click: true,
                input: true,
                submit: true,
                scroll: true,
                rage_click: true,
              },
              api_host: "https://api-eu.mixpanel.com",
              persistence: "localStorage",
            },
          },
        ]
      : [],
});

export { analyticsClient };
